// test2577
(2577 && 0);
